import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthModule } from 'app/fuse-template/core/auth/auth.module';
import { IconsModule } from 'app/fuse-template/core/icons/icons.module';
import { TranslocoCoreModule } from 'app/fuse-template/core/transloco/transloco.module';

@NgModule({
    imports: [AuthModule, IconsModule, TranslocoCoreModule],
    exports: [TranslocoCoreModule],
})
export class CoreModule {
    /**
     * Constructor
     */
    constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
        // Do not allow multiple injections
        if (parentModule) {
            throw new Error('CoreModule has already been loaded. Import this module in the AppModule only.');
        }
    }
}
